<template>
  <div class="crm">
    <page-header title="Customer Registration" breadcrumb="Dashboard > CRM" />
    <div class="card py-4 px-3">
      <!-- <div class="flex justify-between">
        <div>
          <h3 class
        <div>="font-semibold">Dashboard</h3>
        </div>
          <p>Month</p>
        </div>
      </div> -->
      <div class="mt-4">
        <!-- <img
          src="@/assets/images/crm/customer-analytics.png"
          alt="customer analytics"
        /> -->
        <apexchart
          class="w-full"
          type="line"
          height="250"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
      <!-- <div class="flex justify-between text-sm">
        <div>
          <p>
            Total Registerations This Year:
            <span class="font-semibold text-base">123</span>
          </p>
        </div>
        <div>
          <p>This Month: <span class="font-semibold text-base">14</span></p>
        </div>
      </div> -->
    </div>

    <customer-details />
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import CustomerDetails from "./CustomerDetailsTable";

export default {
  components: {
    PageHeader,
    CustomerDetails,
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          toolbar: { show: false },
        },
        stroke: {
          curve: "smooth",
          dashArray: [0, 8],
          width: [2, 2],
        },
        grid: {
          borderColor: "#e7e7e7",
        },
        legend: {
          show: true,
        },
        colors: ["#2E93fA", "#66DA26", "#546E7A", "#E91E63", "#FF9800"],
        fill: {
          type: "solid",
          opacity: 1,
          gradient: {
            shade: "dark",
            inverseColors: false,
            gradientToColors: ["#7367F0", "#b8c2cc"],
            shadeIntensity: 1,
            type: "horizontal",
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 50, 50],
          },
        },
        markers: {
          size: 0,
          hover: {
            size: 3,
          },
        },
        xaxis: {
          labels: {
            style: {
              cssClass: "text-cloudenly-primary-main fill-current",
            },
          },
          axisTicks: {
            show: true,
          },
          categories: [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEPT",
            "OCT",
            "NOV",
            "DEC",
          ],
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          tickAmount: 5,
          labels: {
            style: {
              cssClass: "text-cloudenly-primary-main fill-current",
            },
            formatter: function(val) {
              return val < 0 ? (val / 1000).toFixed(1) + "k" : val;
            },
          },
        },
        tooltip: {
          x: { show: true },
        },
      },
    };
  },
  mounted() {
    this.getGraphData();
  },
  methods: {
    async getGraphData() {
      try {
        const response = await this.$_getGraphData();
        this.logResponse(response);
        this.series = response.data.yearPlot.series;
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style></style>
